export default __webpack_public_path__ + "static/media/dyeing4.b395fd70.png";